import { Injectable, signal } from '@angular/core';

/**
 * State of the "Crystal was updated" prompt. Shown at most once per page load (and the prompt has no
 * dismiss, only Reload), so a chunk that stays unreachable can never produce a reload loop: the
 * reload is always the user's click, never automatic.
 */
@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  readonly visible = signal(false);

  show(): void {
    this.visible.set(true);
  }

  reload(): void {
    window.location.reload();
  }
}
